import { render, staticRenderFns } from "./InternLocoPage.vue?vue&type=template&id=2a24b20e&"
import script from "./InternLocoPage.vue?vue&type=script&lang=js&"
export * from "./InternLocoPage.vue?vue&type=script&lang=js&"
import style0 from "./InternLocoPage.vue?vue&type=style&index=0&id=2a24b20e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports